// jQuery validators must be registerd early (before document ready) hence it is located here
$(function (win, $) {
	"use strict";

	// app.validation = {};

	//re-set all client validation given a jQuery selected form or child
	$.fn.resetValidation = function () {

		var $form = this.closest("form");

		//reset jQuery Validate's internals
		$form.validate(
			{
				unhighlight: function (element, errorClass, validClass) {
					console.log(element);
				}
			}
		).resetForm();

		// Remove error styling
		$form.find(".input-validation-error").removeClass("input-validation-error");

		//reset unobtrusive validation summary, if it exists
		$form.find("[data-valmsg-summary=true]")
            .removeClass("validation-summary-errors")
            .addClass("validation-summary-valid")
            .find("ul").empty();

		//reset unobtrusive field level, if it exists
		$form.find("[data-valmsg-replace]")
            .removeClass("field-validation-error")
            .addClass("field-validation-valid")
            .empty();

		return $form;
	};

	// Required true validation (checkbox)
	$.validator.unobtrusive.adapters.addBool("requiredtrue", "required");

	// Organisation number validation
	$.validator.addMethod("organisationnumber", function (value, element, params) {

		if (value === "" || value === null) {
			triggerInvalid(element);
			return true;
		}
		value = value.match(/^(?:\d{2})?(\d)(\d)(\d)(\d)(\d)(\d)[-]?(\d)(\d)(\d)(\d)$/);
		if (value == null) {
			triggerInvalid(element);
            return false;
		}
		var n;
		var checkSum = 0;
		for (var i = 1; i < value.length; i++) {
			n = parseInt(value[i]);
			if (i % 2 === 0) {
				checkSum += n;
			} else {
				checkSum += (n * 2) % 9 + Math.floor(n / 9) * 9;
			}
		}

		if (checkSum % 10 === 0) {
			triggerValid(element);
            return true;
		}
		triggerInvalid(element);
        return false;

	});

	const triggerInvalid = function (element) {
		if (document.createEvent) {
			const event = document.createEvent("HTMLEvents");
			event.initEvent("invalid", true, true);
			event.eventName = "invalid";
			element.dispatchEvent(event);
		} else {
			const event = document.createEventObject();
			event.eventName = "invalid";
			event.eventType = "invalid";
			element.fireEvent("on" + event.eventType, event);
		}
	}

	const triggerValid = function (element) {
		if (document.createEvent) {
			const event = document.createEvent("HTMLEvents");
			event.initEvent("valid", true, true);
			event.eventName = "valid";
			element.dispatchEvent(event);
		} else {
			const event = document.createEventObject();
			event.eventName = "valid";
			event.eventType = "valid";
			element.fireEvent("on" + event.eventType, event);
		}
	}

    $.validator.unobtrusive.adapters.addBool("organisationnumber");

	$.validator.addMethod("isofage", function (value, element, params) {

		value = ensureSsnWithCenturyAndWithoutDash(value);

        if (value === "" || value === null) return true;
        value = value.match(/(\d{8})[-]?(\d{4})$/);
		if (value === null) return false;
        var today = new Date();
        var birthday = new Date(Date.parse(value[1].substr(0, 4) + "-" + value[1].substr(4, 2) + "-" + value[1].substr(6, 2)));
        var thisBirthday = new Date(today.getFullYear(), birthday.getMonth(), birthday.getDate());

		var diff = today.getFullYear() - birthday.getFullYear();

		if (thisBirthday > today) diff--;

        return diff >= 18;

	});

	function ensureSsnWithCenturyAndWithoutDash(str) {
		str = str.replace(/-/g, '');

		if (str.length === 10) {
			return getProbableCenturyForSsn(str.substring(0, 2)) + str;
		}

		if (str.length === 12) {
			return str;
		}

		return str;
	}

	function getProbableCenturyForSsn(yearStr) {
		const year = parseInt(yearStr, 10);
		if (!isNaN(year)) {
			const currentYear = new Date().getFullYear();
			const century = (currentYear - year - 1).toString().substring(0, 2);
			return century;
		}

		return "";
	}


	$.validator.unobtrusive.adapters.addBool("isofage");

	// Required if validation
	$.validator.addMethod("requiredif", function (value, element, parameters) {
		// If this is an complex object we need to get the full name (example: User.Name.Firstname = User.Name )
		var modelPrefix = element.name.substr(0, element.name.lastIndexOf(".")),
			// Get all elements with this name
			otherElement = modelPrefix ? $("[name='" + modelPrefix + "." + parameters.othername + "']") : $("[name='" + parameters.othername + "']"),
			// Get the type of element, we need this to determine the value
			otherElementType = otherElement.attr("type"),
			// The actual value
			otherElemeneVal;

		// Get the value by type of element
		// If this is a checkbox just set value to true or false depending on if the element is checked
		// (This does not support multiple checkboxes)
		if (otherElementType === "checkbox") {
			otherElemeneVal = otherElement.is(":checked").toString();
		}
			// If this is a radio button, get the currently checked radio button
		else if (otherElementType === "radio") {
			otherElemeneVal = otherElement.filter(":checked").val();
		}
			// Else just get the value
		else {
			otherElemeneVal = otherElement.val();
		}

		// If the condition is true, reuse the existing required field validator functionality
		if (parameters.othervalue === otherElemeneVal) {
			return $.validator.methods.required.call(this, value, element, parameters);
		}

		// If the condition wasn't true, return true (this element was not requried)
		return true;
	});

	$.validator.unobtrusive.adapters.add("requiredif", ["othername", "othervalue"], function (options) {
		options.rules["requiredif"] = {
			othername: options.params["othername"],
			othervalue: options.params["othervalue"]
		};
		options.messages["requiredif"] = options.message;
	});

	// Unique value validation
	$.validator.addMethod("unique", function (value, element, parameters) {
		var isUnique = true;

		$(element).closest("form").find(parameters).not(element).each(function () {
			if (isUnique && value != null && $(this).val().toLowerCase() === value.toLowerCase()) {
				isUnique = false;
			}
		});

		return isUnique;

	});
	$.validator.unobtrusive.adapters.addSingleVal("unique", "selector");

	$.validator.addMethod("requriedyearandmonth", function (value, element, parameters) {
		var isValid = true,
			formGroup = $(element).closest(".form-group");

		console.log("requriedyearandmonth");

		$.each(parameters, function(i, id) {
			var control = formGroup.find("#" + id);

			if (!control.val()) {
				isValid = false;
			}
		});

		return isValid;

	});
	$.validator.unobtrusive.adapters.add("requriedyearandmonth", ["yearpropertyname", "monthpropertyname"], function (options) {
		options.rules["requriedyearandmonth"] = {
			yearpropertyname: options.params["yearpropertyname"],
			monthpropertyname: options.params["monthpropertyname"]
		};
		options.messages["requriedyearandmonth"] = options.message;
	});
	$.validator.setDefaults({
        ignore: ':hidden, [readonly=readonly]'
    });
}(window, jQuery));